import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject, Observable, takeUntil } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { LoginService } from 'src/app/services/login.service';
import { ResultsService } from 'src/app/services/results.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { ResultFilterModel } from 'src/app/shared/models/result-filter.model';

@Component({
  selector: 'ness-results-filter',
  templateUrl: './results-filter.component.html'
})
export class ResultsFilterComponent implements OnInit {

  iconUp: string = 'fa-caret-square-up';
  iconDown: string = 'fa-caret-square-down';
  currentViews: ServerModels.ENESS_REF_SuccessStoryFilters[] = [];
  defaultFilterDateDurationDays: number = AppConstants.filterDateDurationDays;
  fieldDivisions$: Observable<ServerModels.ENESS_REF_FieldDivisions[]> = this._loginService.fieldDivisions$;
  @Output() filterModel = new EventEmitter<ResultFilterModel>();
  filterValues: ResultFilterModel;
  @Input() set storageKey(key: string) {
    if (key) {
      this._storageKey = key;
      let fm: any;
      if (fm = JSON.parse(sessionStorage.getItem(key))) {
        this.cgicCode = fm._cgicCode;
        this.currentView = fm._currentView;
      }
    }
  }

  private _cgicCodeFilter: string = '';
  get cgicCode(): string {
    return this._cgicCodeFilter;
  }

  @Input() set cgicCode(code: string) {
    this._cgicCodeFilter = code;
  }

  private _currentViewFilter: string = '';
  get currentView(): string {
    return this._currentViewFilter;
  }

  set currentView(view: string) {
    this._currentViewFilter = view;
  }

  private _unsubscribe$: Subject<void> = new Subject<void>();
  private _storageKey: string;
  constructor(private _loginService: LoginService,
    private _resultService: ResultsService,
    private _loaderService: LoaderService) { }

  ngOnInit() {
    this.filterValues = new ResultFilterModel(this.cgicCode, this.currentView);
    this._resultService.getFilters().pipe(takeUntil(this._unsubscribe$)).subscribe({
      next: (fv: ServerModels.ENESS_REF_SuccessStoryFilters[]) => this.currentViews = fv,
      error: (err:any) => console.log("Error retrieiving result filters.")
    });
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  applyFilters() {
    this.filterValues = new ResultFilterModel(this.cgicCode, this.currentView);
    sessionStorage.setItem(this._storageKey, JSON.stringify(this.filterValues));
    this.filterModel.emit(this.filterValues);
  }
}
